function slug(value, max) {
  return String(value == null ? '' : value).replace(/[^A-Za-z0-9_-]/g, '').slice(0, max) || 'x';
}

export function loanReminderKey({ ownerId, itemId, loanId, loanedAt, recipientId } = {}) {
  const cycle = loanId || loanedAt || 'x';
  return `lrm_${slug(ownerId, 60)}_${slug(itemId, 60)}_${slug(cycle, 60)}_${slug(recipientId, 60)}`;
}

export function reminderAlreadySent(markData, operationId) {
  return !!operationId && Array.isArray(markData && markData.sentOperationIds) && markData.sentOperationIds.includes(operationId);
}
